import type { SVGProps } from 'react';
const SvgReadMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#read_more_svg__a)">
      <path d="M22 7h-9v2h9V7ZM22 15h-9v2h9v-2ZM22 11h-6v2h6v-2ZM13 12 8 7v4H2v2h6v4l5-5Z" />
    </g>
    <defs>
      <clipPath id="read_more_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReadMore;
